import React from "react";
import { typography } from "@streeteasy/design-system";
import { bool, func, node, string } from "prop-types";

import * as S from "./styled";

const { Caption } = typography;

const TooltipTrigger = ({ handleClick, title }) => (
  <>
    <S.Trigger onClick={handleClick} />
    <S.HiddenLabel>{title}</S.HiddenLabel>
  </>
);

TooltipTrigger.propTypes = {
  handleClick: func.isRequired,
  title: string
};

TooltipTrigger.defaultProps = {
  title: "info"
};

const TooltipContent = ({ children, title }) => (
  <S.TooltipContent>
    {title && <S.TooltipTitle>{title}</S.TooltipTitle>}
    <Caption>{children}</Caption>
  </S.TooltipContent>
);

TooltipContent.propTypes = {
  children: node.isRequired,
  title: string
};

TooltipContent.defaultProps = {
  title: ""
};

const Tooltip = ({ children, handleClick, title, titleVisible }) => (
  <S.PositionedTooltip
    triggerNode={<TooltipTrigger handleClick={handleClick} title={title} />}
  >
    <TooltipContent title={titleVisible ? title : null}>
      {children}
    </TooltipContent>
  </S.PositionedTooltip>
);

Tooltip.propTypes = {
  children: node.isRequired,
  handleClick: func,
  title: string,
  titleVisible: bool
};

Tooltip.defaultProps = {
  handleClick: () => {},
  title: null,
  titleVisible: false
};

export default Tooltip;
